import { render, staticRenderFns } from "./AddUserModal.vue?vue&type=template&id=fb3cc53a"
import script from "./AddUserModal.vue?vue&type=script&lang=js"
export * from "./AddUserModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports